import { useNavigate } from "react-router-dom";
import { posterUrl } from "../api/images";
import { EmptyScreen } from "../components/StatusScreens";
import { useWatchlist, removeFromWatchlist } from "../storage/watchlist";
import { isFutureDated } from "../api/tmdb";
import { yearOf, formatRating } from "../lib/format";

export default function MyListScreen() {
  const watchlist = useWatchlist();
  const list = watchlist.filter((item) => !isFutureDated(item.date)); // hide unreleased titles
  const navigate = useNavigate();

  if (list.length === 0) {
    return (
      <main className="page">
        <div className="page-content">
          <h1 className="page-heading">My List</h1>
          <EmptyScreen
            title="Your list is empty"
            message="Add movies and shows from their detail pages and they will appear here."
          />
        </div>
      </main>
    );
  }

  return (
    <main className="page">
      <div className="page-content">
        <h1 className="page-heading">My List</h1>
        <div className="list-rows">
          {list.map((item) => {
            const year = yearOf(item.date);
            const rating = formatRating(item.rating);
            return (
              <div key={`${item.contentType}-${item.tmdbId}`} className="list-row">
                <button
                  className="list-poster"
                  onClick={() => navigate(item.contentType === "TV_SHOW" ? `/show/${item.tmdbId}` : `/movie/${item.tmdbId}`)}
                  aria-label={item.title}
                >
                  {item.posterPath ? (
                    <img src={posterUrl(item.posterPath)} alt="" loading="lazy" />
                  ) : (
                    <div className="poster-fallback"><span>{item.title}</span></div>
                  )}
                </button>
                <div className="list-info">
                  <button className="list-title" onClick={() => navigate(item.contentType === "TV_SHOW" ? `/show/${item.tmdbId}` : `/movie/${item.tmdbId}`)}>
                    {item.title}
                  </button>
                  <p className="list-meta">
                    {[year, rating && `★ ${rating}`, item.contentType === "TV_SHOW" ? "TV Show" : "Movie"].filter(Boolean).join("  ·  ")}
                  </p>
                  {item.overview && <p className="list-overview">{item.overview}</p>}
                </div>
                <button
                  className="btn btn-ghost btn-sm"
                  onClick={() => removeFromWatchlist(item.contentType, item.tmdbId)}
                >
                  REMOVE
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </main>
  );
}